module.exports = __webpack_public_path__ + "img/sample_map0.e304e240.png";